import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getMolecularData } from "@/api/molecularData";
import type { IGetMolecularDataRequest } from "@/api/molecularData";

export const useGetMolecularData = (params: IGetMolecularDataRequest = {}) => {
  return useQuery({
    queryKey: ["molecular-data", params],
    queryFn: () => getMolecularData(params),
    placeholderData: keepPreviousData,
  });
};
